// zh.js
export default {
  _Update: 'Update',
  // 可以以页面为单位来写，比如首页的内容，写在index字段，个人中心写在center，公共部分写在common部分
  lang: {
    title: 'uView UI',
    intro: '多平台快速开发的UI框架'
  },
  loain: {
    _Inscreverse: 'Registration',
    _AcessoDeMembro: 'Login'
  },
  _buome: {
    _Retornar: 'Return',
    _Salvar: 'Save'
  },

  _placeholder: {
    _Introduza: 'Enter the WeChat ID',
    _IntroduzaMessage:
      'The WeChat ID must start with a letter or underscore and have between 6 and 20 letters, numbers, underscores and/or hyphens.',
    _WhatsApp: 'Enter your WhatsApp ID',
    _WhatsAppMessage: 'Enter 6-40 numbers',
    _Facebook: 'Enter your Facebook ID',
    _FacebookMessage: 'Please enter 3-50 bits of English/numbers/characters',
    _telegram: 'Enter the telegram ID',
    _telegramMessage: 'Enter 5-40 letters/numbers/underlines',
    _Selecione: 'Select the date of birth (once set, it cannot be changed)',
    _PorFavorSenha: 'Please enter the new password',
    _Outros: 'Other verification methods',
    _ConfirmarNovoSenha: 'Confirm New Password',
    _TodasPlataformas: 'All platforms',
    _DetalhesdaSubcategoria: 'Subcategory details',
    _Inserirnomedeusurio: 'Enter username',
    _Introduzapalavrapasse: 'Enter your password'
  },
  menGMen: {
    _NomedeUsuário: 'Username',
    _Desvincular: 'Untie',
    _deTelefone: 'Telephone number',
    _EndereMail: 'E-mail address',
    _GoogleAuthenticator: 'Google Authenticator',
    _SenhadeLogin: 'Login password',
    _SenhadeSaque: 'Withdrawal Password',
    _FoiDefinido: 'It has been defined',
    _NConfigurado: 'Not Configured',
    _Perguntade: 'Security Question',
    _Deletartudo: 'Delete everything',
    _Apostas: 'Betting',
    _Valor: 'Value',
    _Ganhos: 'Earnings',
    _Semdadosdispo: 'No data available',
    _Informapromo: 'Promotion information',
    _Subordinados: 'Direct subordinates',
    _Convite_me: 'Invitation Code',
    _Subordinadoslidos: 'Valid subordinates',
    _pessoas: 'people',
    _Detalhes: 'Details',
    _queCumprir:
      'what is a valid promotional number?(Fulfill all the requirements listed below)',
    _subordinadoMens: "Subordinate's accumulated deposits",
    _ouMais: 'or more',
    _ApostasSubordinado: "Subordinate's accumulated bets"
  },
  _Nenhumjogodisponvel: 'No games available',
  _Misto: 'Mixed',

  _home: {
    _Popularjogos: ' games',
    _Aexibir: ' Displaying ',
    _jogosentre: 'games between',
    _Carregarmais: 'Load more',
    _Eventos: 'Events',
    _Missão: 'Mission',
    _Rebate: 'Rebate',
    _Pendente: 'Pending',
    _VIP: 'VIP',
    _Sorteio: 'Prize draw',
    _Checkin: 'Check in',
    _Convidar: 'Agent',
    _Compartilhar: 'Share',
    _FundodePrevidência: 'Provident Fund',
    _Surpresa: 'Surpresa',
    _Slots: 'Slots',
    _Pescaria: 'Fishing',
    _Demo: 'Demo',
    _Todos: 'All',
    _Mais: 'more',
    _Suporteonline: 'Online support',
    _CentraldeAjuda: 'Help Center',
    _BônusdeSugestão: 'Suggestion Bonus',
    _Segurança: 'Security',
    _Cassino: 'Casino',
    _Jogos: 'Games',
    _Suporte: 'Support',
    _LicenseCompliance: 'License Compliance',
    _Contatenos: 'Contact Us',
    _CanalOficial: 'Official Channel',
    _tis: 'The game is under maintenance',
    _balanceLess1: 'Your balance is less than $',
    _balanceLess2: ', Please make a deposit to play',
    _rechargeLess:
      'Your account is not activated. Please make a deposit of any amount to activate your account and start playing.',
    _rechargeLess2: 'Your deposit is less than $',
    _rechargeLess3: ', Please make a deposit to play',
    _Válidos: 'Valid',
    _Válido: 'Valid',
    _Inválido: 'Invalid',
    _Taxade: 'Rate of',
    _ReceberTudo: 'Receive everything',
    _Podeserresgatadohoje: 'Can be redeemed today',
    _CASSINO: 'CASSINO',
    _entertainment:
      'is an online entertainment website that offers its users a unique sports betting experience. This website is operated by',
    _NovaWave: 'NovaWave Technology N.V.',
    _Caribbeaundern:
      'a company registered in Curaçao, under number 162293, with registered office in Schottegatweg Oost 10, Unit 1-9, Bon Bini Business Center, Willemstad, Curaçao, Dutch Caribbean, an entity duly authorized and licensed by the Government of Curaçao.',
    _accessingBy:
      'By accessing, continuing to use, or browsing this website you agree that we may use certain browser cookies to improve your experience whilst using our site. We only use cookies to enhance your experience, and this does not interfere with your privacy',
    _Distnciaw: 'Distance',
    _Convideumpacote: 'Invite a friend to open a red bonus pack',
    _Recebido: 'Received',
    _Montantefixo: 'Lump sum',
    _jogador: 'Player',
    _payout: 'Payout',
    _Mais: 'More',
    _Saques: 'Withdrawals',
    _Blockchain: 'Blockchain',
    _DownloadAPPMoreDiscounts:
      'Download the APP to participate in more discounts!',
    _BaixarAgora: 'Download Now',
    _Pesquisar: 'Search',
    _BaixeeuseoAPP: 'Download and use the APP',
    _BaixeoAPP: 'Download the APP',
    _aproveitarmaisdescontos: 'enjoy more discounts'
  },

  _VIP: {
    _Lembrete: 'Reminder',
    _LembreteConter:
      'In order to advance to the next level, it is necessary to place additional bets on top of the total accumulated valid bets. For example: if the requirement for valid bets to advance to VIP1 is 1000, and the requirement to advance to VIP2 is 2000, then the member needs to accumulate a total of 1000 + 2000 = 3000 valid bets to advance to VIP2, and so on.',
    _LembreteConterDeposit:
      "To advance to the next level, members need to reach a cumulative deposit. For example, if the deposit requirement for advancing to VIP1 is 30, and the deposit requirement for advancing to VIP2 is 300, then a member's cumulative deposit of 300 can advance to VIP2, and so on.",
    _NívelAtual: 'Current Level',
    _Restantes: 'Remaining',
    _Apostemais: 'Bet more',
    _DepositMore: 'Deposit more',
    _ResgatarTudo: 'Rescue Everything',
    _Histórico: 'History',
    _ListadeníveisVIP: 'List of VIP levels',
    _InstruçõessobreregrasVIP: 'Instructions on VIP rules',
    _Nível: 'Level',
    _Apostaparapromoção: 'Betting for promotion',
    _DepositPromotion: 'Deposit for promotion',
    _BônusDeAumentoDe: 'Increase Bonus ',
    _Bônus: 'Bonus',
    _Ovalortotaldaretiradadiária: 'Number of withdrawals per day',
    _Olimitesuperiordaretiradadiária: 'The upper limit of daily withdrawal',
    _Taxasdeisençãodiáriacaneta: 'Daily Pen Exemption Fees',
    _NumberOfWithdrawals: 'Number of withdrawals',
    _WithdrawalLimit: 'Withdrawal limit',
    _PenExemptionFees: 'Pen Exemption Fees',
    _Totaldedepósitos: 'Total deposits',
    _FundodePrevidência: 'Provident Fund',
    _Depósito: 'Deposit',
    _Retira: 'Remove',
    _Nãosertapado: "Don't be covered up",
    _BônusMáximoNãosertapado: 'Maximum Bonus',
    _LimiteMáximoNãosertapado: 'Maximum Limit',
    _acumulaçãototal0: 'total accumulation',
    _Horário: 'Schedule',
    _Taxadebônus: 'Bonus rate',
    _Taxadebônus: 'Bonus rate',
    _Númerodeapostas: 'Number of bets',
    _Novosrequerimentosparaaposta: 'New betting requirements',
    _Vocêprecisaapostar: 'You need to bet',
    _presenteMeLOfgn: 'Gift method',
    _recarregar:
      'Each time you top up, you will receive a bonus to the value of the 100% top-up. The bonus is deposited into the provident fund account. The more you top up, the more rewards you receive.',
    _Condies: 'Conditions',
    _Cadaprevid:
      'Each time you reload, a new provident fund will be accumulated, so you must complete effective bets 35 times the main amount of the reload each time before you can withdraw the provident fund; if the provident fund is not given or has been capped, you need to complete effective bets 5 times the reload.',
    _BnusMximo: 'Maximum Bonus',
    _gratuitos:
      'During the activity cycle,Number of free gifts,There is no limit to the amount accumulated in the CPF.',
    _Redefinirciclo: 'Reset cycle',
    _retiradoMense_mes:
      'The validity period of the provident fund is 1Per month，Not withdrawn 31 days after the end of the cycle，The provident fund reward will be invalid and the provident fund can only be received once per cycle.',
    _Auditoriamltipla: 'Multiple audits',
    _fundoRetirado:
      'The withdrawn reserve fund bonus requires 15 times actual wagering before requesting withdrawal, with wagering limited to the Unlimited Play Platform.',
    _Recebarestries: 'Receive restrictions',
    _apenasAndroid:
      'Only available for manual redemption on PC、H5、Android-APP、iOS-APP.',
    _Violadasregras: 'Breaking the rules',
    _meSomente:
      'Only the account owner can carry out normal human operations. It is forbidden to rent, use plug-ins, robots, play with different accounts, mutual brushing, arbitration, interfaces, protocols, exploitation of loopholes, group control or other technical means. Otherwise, participation will be canceled or rewards will be deducted, frozen or even blacklisted.',
    _Aexplicainal: 'The final explanation',
    _Paraevitar:
      'In order to avoid differences in the understanding of the text, the platform reserves the right to the final interpretation of this event.',
    _des_1:
      'Promotion standard: if you meet the requirements of the VIP promotion (i.e. the reload or effective bets can meet the conditions), you can advance to the corresponding VIP level and get the corresponding promotion bonus.The bonus can be received from time to time;',
    _des_2:
      'Daily salary: If the daily reload and valid bets meet the daily salary requirements of the current level, you can get the corresponding daily salary bonus. If you advance to several consecutive levels, you can only get the daily wage bonus for the current level.The bonus can be received from time to time;',
    _des_3:
      'Weekly Wage: If the weekly reload and valid bets meet the current level of weekly wage requirements, you can get the corresponding weekly wage bonus. If you advance to several consecutive levels, you can only get the current weekly salary bonus level. The bonus can be received from time to time;',
    _des_4:
      'Monthly Lulu: top up monthly and wager effectively to meet the current monthly Lulu level, and you can get the corresponding monthly prize bonus.The bonus can be received from time to time;',
    _des_5:
      'Reward Expiry Time: The bonus received is available for %d days. If it is not actively redeemed during this period, it will automatically be credited to the account. For example: if a reward is obtained on January 1st and retained for %d days, it will automatically be credited to the account on %d January at 00:00:00.',
    _des_6:
      'Instructions for auditing: the VIP bonus offered can only be withdrawn after fulfilling the 1x rollover requirement (i.e. auditing, wagering or valid bets), regardless of the platform you play on;',
    _des_7:
      'Statements: This function is limited to the normal operations of account holders. It is forbidden to rent accounts, make riskless bets (bets with different accounts, mutual swiping and low odds swiping), vicious arbitrage, use plug-ins, robots, exploitation of agreements, loopholes, interfaces, group control or other technical means of participation; otherwise, once proven, the platform has the right to ban members from logging in, suspend use of our website, and confiscate the bonus and undue winnings, without any special warning;',
    _des_8:
      'Instructions: By claiming the VIP bonus, members are deemed to accept and comply with the corresponding rules. In order to avoid differences in understanding of the text, the platform reserves the final right to interpret this activity. '
  },

  yuebao: {
    _Apostado: 'Bet',
    _Introduaosganhos: 'Introduction to earnings',
    _mens_depositado:
      'The amount deposited in the interest treasury must complete a full cycle in order to generate interest. If it is withdrawn earlier, the cycle will not count towards profits. For example, if the current settlement period is 1 hour, the amount transferred on 2023-01-01 00:00:01 will generate the first interest cycle on 2023-01-01 01:00:01;',
    _CiclodeLiquida: 'Settlement Cycle',
    _horasatualde: 'The current interest settlement period is 1 hour;',
    _Taxadejurosanual: 'Annual interest rate',
    _menNemsn: ' The current annual interest rate is 100%;',
    _Frmuladelculo: 'Calculation formula',
    _LucroDos:
      'Interest income = deposit amount * annual interest rate / settlement period;',
    _Exemplo: 'Example',
    _Umem_anual:
      'A deposit of 10,000 on 01/01/2023 at 00:00:01, with an annual interest rate of 100% and a settlement period of 1 hour, has its first interest yield on 2023-01-01 01:00:01. The calculation is as follows',
    _PrimeiroMensDejuros:
      'First interest yield = 10,000*100%/365 days/24 hours*1 hour = 1.141552',
    _Limiardeentrada: 'Input threshold',
    _Limitedejuros: 'Interest limit',
    _ltiplodeauditoria: 'Audit multiple',
    _Declaradoevento: 'Event declaration',
    _Explica: 'Explanation',
    _valorCadaIgual:
      'The value of each transfer must be greater than or equal to 50 (i.e. ≥ 50), with no upper limit on the transfer amount. The more you transfer, the higher the profit;',
    _taxaDeIurosAtual:
      'There is no limit to the current interest rate. Remember to charge your rent regularly or frequently to avoid losing more income;',
    _Depositado: 'Deposited',
    _Tempodereivindica: 'Claiming time',
    _resgatarPode:
      'You can redeem on the next day, which means that the interest generated on the same day can be claimed after 00:00 the next day.',
    _ensbeConemauditoria:
      'The current audit multiple is 30 times (wagering volume requirement). This means that interest received must be wagered before withdrawal. Only interest received requires auditing, while the principal amount transferred in or out does not require auditing;',
    _Estalimitada:
      "This function is limited to the account. I have a normal gambling betting and it is forbidden to rent an account, no risk bets (for gambling, pairing, low compensation, brushing water), Malicious arbitrage, using plug -in processes, robots, robots use agreements, vulnerabilities, interfaces,Group control or other technical means are prohibited. Once verified, the platform reserves the right to terminate members' logins, suspend members' use of the site and confiscate bonuses and improper profits without prior notice;",
    _Ciclodeassentamento1horas: 'Settling cycle\n1 hours',
    _Coleçãocumulativa: 'Cumulative collection',
    _QuandoNmmembro:
      'When a member receives the Yibao reward, the platform will assume that the member agrees and complies with the corresponding conditions and other relevant regulations. To avoid ambiguity in the understanding of the text, the platform reserves the final right to interpret this event;',
    _MáximodejurosIlimitado: 'Maximum interest\nUnlimited',
    _TaxadeJurosAnual100: 'Annual Interest Rate 100.00%',
    _Depósito: 'Deposit',
    _Transferir: 'Download',
    _Receber: 'Receive',
    _Horas: 'Hours',
    _Tipos: 'Types',
    _Quantia: 'Amount',
    _RendaAcumulada0: 'Accumulated Income',
    actiVCo: [
      {
        text: 'Today',
        value: 0
      },
      {
        text: 'Yesterday',
        value: 1
      },
      {
        text: 'Last 7 Days',
        value: 2
      },
      {
        text: 'Last 15 Days',
        value: 3
      },
      {
        text: 'Last 30 Days',
        value: 4
      }
    ],
    actiVCo1: [
      {
        text: 'Everything',
        value: 0
      },
      {
        text: 'Deposit',
        value: 1
      },
      {
        text: 'Download',
        value: 2
      },
      {
        text: 'Receive Balance',
        value: 3
      }
    ]
  },
  description: 'No Records',

  toolbar: [
    {
      title: 'Initiativeo'
    },
    {
      title: 'Promotiono'
    },
    {
      title: 'Agente'
    },
    {
      title: 'Supporte'
    },
    {
      title: 'Profilel'
    }
  ],
  toolbarConter: {
    _Inicio: 'Home',
    _Inicio2: 'Home',
    _Promoção: 'Promotion',
    _Agente: 'Agent',
    _Suporte: 'Support',
    _Perfil: 'mine',
    _Depósito: 'Deposit',
    _Saque: 'Withdrawal',
    _Login: 'Login',
    _Registro: 'Register'
  },

  popup: {
    nav: [
      {
        title: 'Popular'
      },
      {
        title: 'Slots'
      },
      {
        title: 'Fishing'
      },
      {
        title: 'Demo'
      },
      {
        title: 'Recente'
      },
      {
        title: 'Favorites'
      }
    ],
    nav_31: [
      {
        title: 'Popular'
      },
      {
        title: 'Slots'
      },
      {
        title: 'Blockchain'
      },
      {
        title: 'Fishing'
      },
      {
        title: 'Demo'
      },
      {
        title: 'Recente'
      },
      {
        title: 'Favorites'
      }
    ],
    _Blockchain: 'Blockchain',
    _parareceber: 'to receive',
    _TaxadeRebate: 'Taxa de Rebate',
    _Recompensas: 'Recompensas',
    _Slots: 'Slots',
    _Demo: 'Demo',
    _Recente: 'Recent',
    _Popular: 'Popular',
    _Pescaria: 'Fishing',
    _Blockchain: 'Blockchain',
    _Favoritos: 'Favorites',
    _Apostas: 'Betting',
    _Agente: 'Agent',
    _Promoção: 'Promotion',
    _Eventos: 'Events',
    _Histórico: 'History',
    _FundodePrevidência: 'Provident Fund',
    _Pendente: 'Pending',
    _Juros: 'Interest',
    _VIP: 'VIP',
    _Português: 'Portuguese',
    _BaixarApp: 'Download App',
    _Suporte: 'Support',
    _FAQ: 'FAQ',
    _Sobre: 'About',
    _Aexibir: 'Displaying',
    _jogosEntre: 'games between',
    _PopularIogos: 'Popular games',
    _Carregarmais: 'Load more',
    _BônusDeAumentoDeNível: 'Level Up Bonus',
    _BônusSemanal: 'Weekly Bonus',
    _BônusMensal: 'Monthly Bonus',
    _PrivilégioVIP: 'VIP privilege',
    _Detalhesdoregistro: 'Registration details',
    _Regrasdejuros: 'Interest rules',
    _Totalderegistros: 'Total records',
    _RequisitosDeapostas: 'Betting requirements',
    _Regras: 'Rules'
  },

  share: {
    _LinkdeConvite: 'Invitation link',
    _MeusDados: 'My Data',
    _TodososDados: 'All Data',
    _Desempenho: 'Performance',
    _Comissãopor: 'Commission for',
    _Comissão: 'Commission',
    _DadosdoSubordinado: 'Data of the Subordinate',
    _ApostasdosSubordinados: "Subordinates' bets",
    _TaxadeComissão: 'Commission fee',
    _CadastrarSubordinados: 'Register Subordinates'
  },
  notice: {
    _Suporte: 'Support',
    _Notícia: 'News',
    _Notificação: 'Notification',
    _PainelRolante: 'Rolling Panel',
    _BônusdeSugestão: 'Suggestion Bonus',
    _TelegramSuporte: 'Telegram Support',
    _FacebookSuporte: 'Facebook Support',
    _WhatsAppSuporte: 'WhatsApp Support',
    _FAQ: 'FAQ',
    _PerguntasFreqüentes: 'Frequently Asked Questions',
    _Apoioonline: 'Online support',
    _Contactaragora: 'Contact us now',
    _Conversecomoserv:
      'Talk to professional online customer service to solve your problems',
    _SemMensagem: 'No Message',
    text1: '24-hour online customer service',
    text2:
      'Customer service available to help solve problems and answer questions.',
    text3: 'Contact',
    text4: 'Official Channel',
    text5: 'Official Channel ®',
    text6: 'Telegram customer service',
    text7: 'WhatsApp customer service'
  },
  Recharge: {
    _PaymentMethod: 'Payment Method',
    _Firstdeposit: 'First deposit',
    _withBonus: 'With Bonus'
  },
  withdraw: {
    _Solicitarsaque: 'Request withdrawal',
    _TarefasdeApostas: 'Betting Tasks',
    _Contapararecebimento: 'Receipt account',
    _RegistrodeSaques: 'Withdrawal Register',
    _Paraasegurança:
      'For the security of your account, enter the withdrawal password',
    _EsqueceuaSenha: 'Forgot your password?',
    _Próximo: 'Next',
    _InserirSenha: 'Enter Password',
    _VerificarSenhadeSaque: 'Verify Withdrawal Password',
    _DetalhesdeRetiradas: 'Withdrawal details',
    _Tipodetransação: 'Type of transaction',
    _MétododeRetirada: 'Withdrawal method',
    _HoradeCriação: 'Creation Time',
    _Horadeexecução: 'Execution time',
    _NúmerodoPedido: 'Order Number',
    _Vocêtambém: 'You also need to bet effectively',
    _VocêtambémRight: 'to withdraw money!',
    _Vezes: 'Times',
    _Apostaválidanecessária: 'Valid bet required',
    _Adicionarponto: 'Add point',
    _Completado: 'Completed',
    _fonte: 'source',
    _Saldo: 'Balance',
    _Vocêprecisaapostar: 'You need to bet',
    _sacardinheiro: 'withdraw money',
    _Bonus: 'Bonus',
    _Estataxade: 'This handling fee≈$ 0,00 (estimated arrival$ 1.111,00)',
    _Tudo: 'Everything',
    _Vejaasregrasparadetalhes: 'See the rules for details',
    _Ganharjuros: 'Earning interest',
    _Confirmarretirada: 'Confirm withdrawal',
    _TotaldeSaques: 'Total Withdrawals',
    _EmitindoparaPIX: 'Issuing toPIX',
    _AdicionarPIX: 'Add PIX',
    _Confirmar: 'Confirm',
    _Verifique:
      "Check your name and card number carefully, otherwise you won't be credited",
    _Contapararecebimento: 'Receipt account',
    _Detalhesdatarefadeapostas: 'Betting task details',
    _Tipodefonte: 'Type of font',
    _ObterAdicionarpontos: 'Get/Add points',
    _Exigirmultiplicadordeaposta: 'Require bet multiplier',
    _Apostaválidanecessária: 'Valid bet required',
    _Apostajáválida: 'Bet already valid',
    _Vocêprecisaapostar: 'You need to bet',
    _Statusdatarefa: 'Task status',
    _TempodeConclusão: 'Completion Time',
    _Depósito: 'Deposit',
    _Adicionar: 'Add',
    _EsperandoRetirada: 'Waiting for pick-up',
    _RetiradaBemSucedida: 'Successful Withdrawal',
    _RetiradaCancelada: 'Withdrawal Canceled',
    _Aguardandoapostas: 'Waiting for bets',
    _Têmemmão: "They're on hand",
    _Completado: 'Completed',
    _Abandonado: 'Abandoned',
    _AdicionarConta: 'Add Account',
    _Anual: 'Annual',
    _Lobby: 'Lobby'
  },
  subgame: {
    _Slots: 'Slots'
  },

  promote: {
    _MeuLink: 'My Link',
    _MododeAgente: 'Agent Mode',
    _RededoAgente: 'Agent Network',
    _Nœud: 'Infinite level difference (Day node)',
    _Coletável: 'Collectible',
    _Subordinadosdiretos: 'Direct subordinates',
    _CódigodeConvite: 'Invitation Code',
    _Receber: 'Receive',
    _Histórico: 'History',
    _CliqueparaSalvar: 'Click to save',
    _Adicionarmembrosdiretos: 'Add direct members',
    _PrimeirosDepósitos: 'First deposits',
    _Depósitos: 'Deposits',
    _Depósito: 'Deposit',
    _Desempenho: 'Performance',
    _Comissão: 'Commission',
    _ReportDataTitle: [
      "Today's direct report data",
      "Yesterday's data from the direct report",
      "This week's direct report data",
      'Direct report data from last week',
      "This month's data for the direct report",
      'Direct report data from last month'
    ],
    _Datasummary: 'Data summary',
    _MeuTime: 'My Team',
    _Desempenho: 'Performance',
    _Comissão: 'Commission',
    _Membros: 'Members',
    _MembrosDiretos: 'Direct Members',
    _OutrosMembros: 'Other Members',
    _RendimentoTotal: 'Total Income',
    _Rendimento: 'Income',
    _DDireto: 'D. Direct',
    _DdosOutros: 'D. of Others',
    _ComissõesTotais: 'Total Commissions',
    _MemberID: 'Member ID',
    _ApostasVálidas: 'Valid Bets',
    _RecargaDireta: 'Direct Recharge',
    _Primeirarecargadireta: 'First direct recharge',
    _OutroDepósito: 'Other Deposit',
    _Outrasrecargasiniciais: 'Other initial refills',
    _DepósitoTotal: 'Total Deposit',
    _Totaldejogadoresfazendoprimeirosdepósitos:
      'Total number of players making first deposits',
    _IDdeMembro: 'Member ID',
    _ComissãoDireta: 'Direct Commission',
    _OutraComissão: 'Other Commission',
    _SubordinadosDele: 'His subordinates',
    _Depósito: 'Deposit',
    _DatadeCadastro: 'Registration Date',
    _ApostasVálidas: 'Valid Bets',
    _Datadelogin: 'Login date',
    _Atual: 'Current',
    _Estado: 'State',
    _Númerodeinscritos: 'Number of applicants',
    _Apostasválidas: 'Valid bets',
    _Apostaválidadireta: 'Direct valid bet',
    _VDdiretas: 'Direct V/D',
    _Depósitos: 'Deposits',
    _PrimeirosDepósitos: 'First deposits',
    _Depósito: 'Deposit',
    _ApostasVálidas: 'Valid Bets',
    _Ontem: 'Yesterday',
    _Hoje: 'Today',
    _EstáSemana: 'This week',
    _ÚltimaSemana: 'Last Week',
    _EsteMês: 'This Month',
    _MêsPassado: 'Last Month',
    _DataLiquidação: 'Settlement Date',
    _customerservice: 'customer service',
    _Desempenhototal: 'Total performance',
    _RetornodeComiss: 'Commission return',
    _escalonada: 'Staggered commission',
    _contribuicomissão: 'contributes commission',
    _Contribuipara: 'It contributes to',
    _Dediferenciais: 'Differentials',
    _Donível: 'The level',
    _Semdenível: 'No difference in level',
    _Umexemplo: 'An example is the following',
    _Comisde: 'Commission',
    _UmexemploSuponha:
      "Suppose that actual bets from 0 to 10,000 will receive a commission of 100 (i.e. 1%) for every 10,000, and actual bets above 10,000 will receive a commission of 300 for every 10,000 (i.e. 3%), A was the first to discover business opportunities on this site and immediately developed B1, B2 and B3. B1 further developed C1 and C2. B2 developed no subordinates, and B3 developed the relatively powerful C3. On the second day, B1's effective bet is 500, B2's effective bet is 3,000, B3's effective bet is 2,000, C1's effective bet is 1,000, C2's effective bet is 2,000 and C3's effective bet is up to 20,000. ",
    _UmexemploEntseguinte:
      'So the method of calculating the rent between them is as follows',
    _Umexemplocontribui: 'direct contributions from',
    _semSubordinados: 'no subordinates',
    _UmexemplodiretaMe: 'direct contribution from',
    _UmexemploAlcontribui:
      " In addition to the contributions of direct reports B1, B2 and B3, A's commission also comes from the contributions of other reports C1, C2 and C3, as follows",
    _Comissdiretade: 'Direct',
    _Outrascomissesde: 'Other',
    _dascontribui: 'contributions',
    _Comisstotalde: 'Total commission of',
    _diretoOutro: 'direct + other',
    _Resumo: 'Summary',
    _Equipedireta: 'Direct team',
    _EquipediretaDes:
      'refers to the subordinates developed directly by A, i.e. the first level of relationship with A, collectively referred to as the direct team. ',
    _Outrasequipes: 'Other teams',
    _OutrasequipesDes:
      'It refers to those that are developed by subordinates of A. They have a second-level relationship with A or above, i.e. subordinates of subordinates, and subordinates of subordinates. etc., collectively referred to as other teams; as this model and agency can develop unlimited subordinates, for convenience of explanation, this article takes only the 2-level structure as an example.',
    _Total: 'Total',
    _Vlidoouno: 'Valid or not',
    _menregistro: 'Time of registration',
    _DetalhesMe_me: 'Expansion details',
    _Lucroeperdademembro: 'Profit and loss of limb',
    _Resgatardesconto: 'Redeem discount',
    _Detalhesdaaposta: 'Betting details',
    _Subordinadosde: 'Subordinates of',
    _Plataformadejogo: 'Game platform',
    _Nomedojogo: 'Name of the game',
    _ApostasVálidas: 'Valid Bets',
    _dosmembros: 'V/D of members',
    _Normal: 'Normal',
    _Lock: 'Lock',
    _Totaldeapostas: 'Total bets',
    _Comissrecebida: 'Commission received',
    _TGServio: 'Telegram Service',
    _WSServio: 'WhatsApp Service',
    _deAtividade: 'Activity Level',
    _Lembreteimportante: 'Important reminder',
    _Pontosdesorteatuais: 'Current lucky points',
    _Vocaindaprecisaapostar: 'You still have to bet',
    _paraobter: 'to get',
    _Pontosdesorte: 'Lucky points',
    _RODAR: 'WHEEL',
    _RodaPrata: 'Silver Wheel',
    _RodaOuro: 'Golden Wheel',
    _RodaDiamante: 'Diamond Wheel',
    _Perdasdeontem: "Yesterday's losses",
    _Bnusdesuportehoje: "Today's support bonus",
    _Perdasdeontem2: "Last week's losses",
    _Bnusdesuportehoje2: 'Subsidies this week',
    _Valordaperda: 'Value of the loss',
    _PrmiosExtra: 'Extra prizes',
    _recompensasMen_me: 'There are no rewards to be received at the moment',
    _Primeirodepsito: 'First deposit',
    _Recompensa: 'Reward',
    _Dispositivoatual: 'Current device',
    _Aplicativo: 'Application',
    _Versão: 'Version',
    _Tipodeequipamento: 'Type of equipment',
    _Sistema: 'System',
    _ÁreaIP: 'IP Area',
    _Horáriodelogin: 'Login times',
    _Outrosdispositivos: 'Other devices'
  },

  mine: {
    _RecuperaroSaldo: 'Recover Balance',
    _Conta: 'Account',
    _Apostas: 'Betting',
    _Relatório: 'Report',
    _GestãoRetiradas: 'Withdrawal Management',
    _Convidar: 'Agent',
    _Dados: 'Data',
    _Segurança: 'Security',
    _Música: 'Music',
    _Idioma: 'Language',
    _FAQ: 'FAQ',
    _BônusdeSugestão: 'Suggestion Bonus',
    _Façaloginnodispositivo: 'Log in to the device',
    _Sobre: 'About',
    _Sair: 'Exit',
    _Suporte: 'Support',
    _Mensagens: 'Messages',
    _Dados: 'Data',
    _Confirmarsaída: 'Confirm departure',
    _Cancelar: 'Cancel',
    _Desejaterminarsessãodaconta: 'Do you want to log out of your account?',
    _Conta: 'Account',
    _Lembrete: 'Reminder',
    _Saque: 'Withdrawal',
    _Depósito: 'Deposit',
    _Juros: 'Interest',
    _FundodePrevidência: 'Provident Fund',
    _Apostaparapromoção: 'Betting for promotion',
    _Restantes: 'Remaining',
    _Valorrestanteparaaposta: 'Amount left to bet',
    _RemainingDepositAmount: 'Amount left to deposit',
    _DepositPromotion: 'Deposit for promotion',
    _SenhadeLogin: 'Login Password',
    _Cashback: 'Cash back',
    _unlogin_tip1: 'Please first ',
    _unlogin_tip2: 'Login ',
    _unlogin_tip3: 'Or ',
    _unlogin_tip4: 'Register',
    _function1: 'Interest',
    _function2: 'My Records',
    _function3: 'Withdrawal management',
    _function4: 'VIP',
    _function5: 'Promotion',
    _function6: 'Data',
    _function7: 'Security',
    _function8: 'Find us',
    _function9: 'Language',
    _function10: 'FAQ',
    _function11: 'Referral Bonus',
    _function12: 'Log in to the device',
    _function13: 'Exit'
  },

  Login: {
    _Login: 'Login',
    _Registro: 'Register',
    _Depósito: 'Deposit',
    _Saque: 'Withdrawal',
    _Juros: 'Interest',
    _RegistrodeDepósito: 'Deposit Registration',
    _Depósitoonline: 'Online deposit',
    _Expandir: 'Expand',
    _Fechar: 'Close',
    _MínimoRechare: 'Minimum ',
    _MáximoRechare: ', Maximum ',
    _Lembrete:
      "Reminder：Click on 'Buy Balance', select the amount you need, top up to increase your points! !",
    _RecarregueAgora: 'Recharge Now',
    DepositeAgora: 'Deposit Now',
    _RegistrodeDepósito: 'Deposit Registration',
    _Abraseuaplicativo:
      'Open your payment app and scan or copy and paste the QR code below to complete your purchase;',
    _Estecódigo:
      'This QR code can only be paid for once. If you need to pay again, come back and download it;',
    _Apósopagamento:
      'Once the payment has been successful, you can return to the game lobby and wait for the points to be added!',
    _DepósitoTotal: 'Total Deposit',
    _Pagamento: 'Payment',
    _Pendente: 'Pending',
    _Jápago: 'Successful Recharge',
    _PedidoExpirado: 'Expired order',
    _Tempoefetivo: 'Effective time',
    _CopiarcódigoQR: 'Copy QR code',
    _EndereçodocódigoQR: 'QR code address',
    _Statusdopedido: 'Order status',
    _RegistrosdeAuditoria: 'Audit records',
    _HoradeCriação: 'Creation Time',
    _NúmerodoPedido: 'Order Number',
    _Númerodopedidodocomerciante: 'Merchant order number',
    _Lembre: 'Remember your account password',
    _Suporte: 'Support Mobile Number/Account Login',
    _Suporteaocliente: 'Customer support',
    _JogarGrátis: 'Play Demo',
    _EsqueceuaSenha: 'Forgot Password',
    _dengLuPa: 'Please enter Mobile Number/Account',
    _Senha: 'Password',
    _SuporteContaRegistro: 'Supports only Account Registration',
    _Registrodocódigodeverificação: 'Registration of the verification code',
    _Cadastrodesenha: 'Password registration',
    _accAcrt:
      'The currency determines the third-party games and payment methods and cannot be changed.',
    _Tenhomaisde:
      'I am +18 years old, I have read and agree to the Terms of Use',
    _Tenhomaisde2: 'I have read and agree with the',
    _AcordodeUsuário: 'User Agreement',
    _AcordodeUsuário2: 'User Agreement',
    _Confirme: 'Confirm the password again, the same as the password!',
    _DigiteoNúmerodoCelular: 'Enter the Mobile Number',
    _VerificaçãodeID: 'ID verification',
    _RedefiniçãodeSenha: 'Password Reset',
    _Terminar: 'Finish',
    _ErroNo: 'Account format error,4-16 characters, supports English/numbers',
    _caracteresMens:
      '6-16 characters, including at least two letters/numbers/symbols',
    _vazioestar: 'Mobile NumberField must not be empty',
    _Seguintes: 'Next',
    _realName:
      'Fill in the real name and make it convenient for later withdrawal!',
    newText1: 'Log in with WhatsApp to video chat with real women',
    newText2: 'Enjoy more exciting content!',
    newText3: 'Please enter WhatsApp Phone number',
    newText4: 'Enter Code on Your Phone',
    newText5: 'Associating WhatsApp account',
    newText6: 'Copy to WhatsApp',
    newText7: 'The pairing code has been copied, please paste it in WhatsApp',
    newText8: 'Please pay attention to the WhatsApp popup next.',
    newText9: 'Verification Code:',
    newText10: 'RETRY',
    newText11: 'Enter your phone number',
    newText12: 'Please enter a valid phone number',
    newText13: 'Set password',
    newText14: 'Enter your password',
    newText15: 'Password cannot be less than six characters',
    newText16: 'Password too simple',
    newText17: 'MAX RETRIES REACHED',
    newText18: 'Max retries reached.Please try again later.'
  },

  components: {
    _copySuccess: 'Copy Success',
    _Registradocomsucesso: 'Successfully registered',
    _Vamosjogaragora: "Let's play now",
    _CheckInDi: 'Check In Day',
    _Resgatado: 'Rescued',
    _Depósitoobrigatrio: 'Mandatory deposit',
    _Apostaobrigatri: 'Compulsory bet',
    _Entrar: 'Enter',
    _Check_insconsecutivos: 'Consecutive check-ins',
    _Falhanocheckin: 'Check-in failure',
    _Irparadepsito: 'Go to deposit',
    _Topo: 'Top',
    _TOPO_1: 'TOP',
    _Encontre_nos: 'Find us',
    _LoginRpido: 'Quick Login',
    _GoogleLogin: 'Google Login',
    _CanalOficial: 'Official Channel',
    _Telegramoficial: 'Official Telegram',
    _Instagramoficial: 'Official Instagram',
    _Siteoficial: 'Official website',
    _DatadeInício: 'Start Date',
    _DatadeFim: 'End Date',
    _Confimar: 'Confimar',
    _Preencha: 'Fill in the information correctly: The CPF of the account that',
    _normalmente: 'requested this payment to be credited normally',
    _Wrongamount: 'Wrong amount',
    _Introduzaoseunomereal: 'Enter your real name',
    _Strength: 'Strength',
    _IntroduzadoCPF: 'Enter the 11-digit CPF number',
    _paymentpage: 'Please wait, jump to the payment page!',
    _Deptodo: 'Deposit Method',
    _Canalderecarga: 'Recharge channel',
    _Bnusdeprimeirodepsito: 'First deposit bonus',
    _hojeNovamente: "Don't show it again today",
    _Ocultarpermanenfemente: 'Hide permanently',
    _Prosseguir: 'Continue',
    _Total_deapostas: 'Total bets during the event',
    _ValorSorteUtilizado: 'Luck value used',
    _Valordasorteexpirado: 'Lucky draw expired',
    _ValorSortedisponvel: 'Lucky amount available',
    _Containsira: 'Enter Account',
    _novamentefavor: 'Please confirm your password again',
    _Brasil55: 'Brazil（+55）',
    _Registrar: 'Register',
    _Registrovinculativo: 'Binding registration',
    _PorfavorinsiraConta: 'Please enter Account',
    _mboloscaracteres6_16:
      '6-16 characters, including at least two /n letters/numbers/symbols',
    _apenasM_Registro: 'Supports Registration Account only',
    _CelularRegistroMe: 'Supports only Mobile Number Registration',
    _Verifiqueacordo: 'Check the user agreement first',
    _vinculadoCPF: 'Invalid or linked CPF',
    _digitenovamente: 'The account does not support 6-12 pure digits, type again',
    _suporta_dr_55: 'supports 10-11 mobile numbers, enter it again',
    _Esteonmerodo: 'This is',
    _Estaaconta: 'This is the bill',
    _SuporteapenasContaLogin: 'Login account only support',
    _SuporteapenasdoCelularLogin: 'Support only Mobile Number Login',
    _DigiteoConta: 'Enter the Account',
    _Digite_Celular_e: 'Enter Mobile Number/Account',
    _celularSuporta: 'supports 10-11 mobile numbers',
    _inglMbolos_men: '6-16 digits, English/numbers/symbols',
    _novamenteConfirme: 'Confirm the password again, the same as the password!',
    _recebera: 'You will receive',
    _evento: 'Event Bonus',
    _coletar: '(Remember to collect)',
    _Deppsito: 'Deposit Offer',
    _Participacao: 'Automatic participation in the following activities'
  },
  RecuperaroSaldo: {
    _RecuperaroSaldo: 'Recover Balance',
    _Saldoatual: 'Current balance',
    _Umcliquepararecuperar: 'One click to recover',
    _yaTeng:
      'You can only retrieve the integer multiple of the balance (i.e. no decimal point)',
    _Tudos: 'All',
    _Pesquisadeplataforma: 'Platform search'
  },

  report: {
    _Conta: 'Account',
    _Apostas: 'Betting',
    _Relatório: 'Report',
    _Valorcumulativodaaposta: 'Cumulative bet amount',
    _TotaldeApostasVálidas: 'Total Qualifying Bets',
    _TotaldeV: 'Total V/D',
    _DepósitoTotal: 'Total Deposit',
    _TotaldeSaques: 'Total Withdrawals',
    _AcumuladoTotal: 'Cumulative Total',
    _Saldo: 'Balance',
    _ApostasVálidas: 'Valid Bets',
    _GanhosePerdas: 'Gains and losses',
    _NúmerodaNota: 'Note number'
  },

  security: {
    _SenhadeSaque: 'Withdrawal Password',
    _Paraase:
      'For the security of your funds, you first need to set a withdrawal password!',
    _Definasuasenhadesaque: 'Set your withdrawal password',
    _NovaSenhadeSaque: 'New Withdrawal Password',
    _Nãomesmosounúmeroscontínuos: 'Cannot be 6 or continuous numbers',
    _Atenção:
      'Please note: The withdrawal password protects your funds and is extremely important. Keep it secret to avoid any financial loss.',
    _Confirmar: 'Confirm',
    _Senhaincorreta: 'Incorrect password, type again!',
    _Confirmenova: 'Confirm the new withdrawal password',
    _AlterarSenhadeSaque: 'Change Withdrawal Password'
  },
  _homeTile_tab: {
    _meCmeTen: 'PIX account cannot be empty',
    _primeiroprecisa: 'You need to establish a withdrawal password first',
    _VerifiqueAntiga: 'Check the old login password',
    _Convideumapessoa: 'Recommend friends to open the Prize Chest',
    _CupomRecompensas: 'Rewards Coupon',
    _Centrodemensagens: 'Message center',
    _Girodasorte: 'Lucky spin',
    _DetalhesdoDepsito: 'Deposit Details',
    _campodeNomereal: 'The real name field cannot be empty',
    _Descride: 'Description of',
    _Explicao: 'Explanation',
    _Resumodasregras: 'Summary of rules',
    _importaquando:
      'No matter when you enter, from whom you are subordinate, no matter what level you are at, your income will never be affected and you no longer suffer the losses of subordinates of others., development is not restricted. This is an absolutely fair and impartial agency model, and no one will always be down just because they got in late.',
    _tenhaEmbora:
      'Although B3 joined relatively late and is subordinate to A, his subordinate C3 is very powerful and has a direct performance of 20,000, allowing B3 to directly enjoy higher commissions. The proportion is 3%. ',
    _preguiBeneficiar:
      'B2 can be lazy and will not benefit if he does not develop his subordinates.',
    _menTenMensg:
      'B1 has subordinates C1 and C2. As the direct performance is 3,000, the corresponding discount index is 1%.o correspondiente es del 1%.',
    _contribuiComiss: 'A The contribution fee is 0.',
    _diretoDesempenho:
      'The direct performance of A is 5,500 and other performance is 20,000 (due to C3 power). The total performance is 28,500 and the commission corresponding to the rate is 3%. As B1 has a total performance of 3,000 and enjoys a discount of only 1%, while A has a total performance of 28,500 and enjoys a discount rate of 3%, then there will be a discount difference between A and B1. The difference is: 3% -1% =2%, this difference is the part contributed by C1 and C2 to A, so C1 and C2 contribute to A: (1000+2000)* 2%=60, there is no extreme difference between A and B3, so C3',
    _Emandamento: 'Ongoing',
    _ltimosDias2: 'Last 2 months',
    _ltimosDias3: 'Last 3 months',
    _ltimosDias7: 'Last 7 Days',
    _ltimosDias15: 'Last 15 Days',
    _ltimosDias30: 'Last 30 Days',
    _Quasedias60: 'Almost 60 days',
    _TodososStatus: 'All Status',
    _NoLiquidado: 'Not Liquidated',
    _Liquidado: 'Settled',
    _Pedidocancelado: 'Order cancelled',
    _TodososTipos: 'All Types',
    _TrocadeFundos: 'Exchange of Funds',
    _RecargadeMembro: 'Member Reload',
    _SaquedeMembro: 'Member Withdrawal',
    _LiquidaodoComerciante: 'Settlement of the Merchant',
    _CorreodeFundo: 'Background Correction',
    _TaxadeRebate: 'Rebate Rate',
    _Bonus: 'Bonus',
    _Distribudo: 'Distributed'
  },
  noticeInfo: {
    _menCmensEscaneie:
      'Scan the QR code or open the invitation link in a browser. Download the game and sign up, then use your unique QR code or invitation link to invite others.',
    _menCmensClique:
      "Click 'Promotion' in the lobby to enter the promotion page. Your unique QR code and promotional link can be found at the bottom. Save the image and share it.",
    _menCmensrendimento:
      "Yield refers to the player's valid bets in the game. For example, if you promoted a player who made 1,000 valid bets, that equals 1,000 performance contributions.",
    _menCmenscliqueverificar:
      "Go to 'Promotions' and click on' Performance 'to check your performance level. You can also click on 'My Commission' to view your commission and settlement history.",
    _menCmensVoce:
      "You can withdraw money by clicking 'Withdraw Money' by entering the correct bank card details.",
    _menCmensApos:
      'After reloading, players must place valid bets in the game. The withdrawal transaction will only be completed after reviewing this request.',
    _menCmensEscaneie_title: 'How to become an agent?',
    _menCmensClique_title: 'Where can I share the invitation code?',
    _menCmensrendimento_title: 'How is performance calculated?',
    _menCmenscliqueverificar_title:
      'Where can I check my performance level and commission?',
    _menCmensVoce_title: 'How to withdraw money?',
    _menCmensApos_title:
      'What is the requirement to recharge and withdraw money?',
    _Outrasperguntas: 'Other questions',
    _PerguntasSobrecoleao: 'Collection questions',
    _Perguntasderecarga: 'Reload questions',
    _Perguntasdojogo: 'Game questions',
    _SistemadeMsica: 'Music System',
    _MinhasMsicas: 'My Songs',
    _Ciclo: 'Cycle',
    _Baixado: 'Downloaded'
  },
  common: {
    // ......
    title1: 'Special games',
    mineText1: 'Login to earn bonuses',
    mineText2: 'Standard display information',
    mineText3: 'Check In Daily',
    mineText4: 'Log in every day and enjoy countless gifts!',
    mineText5: 'More events',
    mineText6:
      'Please download and login to the APP、Login to the mobile web page collect it',
    mineText7: 'Quick function'
  },
  index: {
    // ......
  }
};
